import { useEffect, useState } from "react"
import {
  oauthMessageTypes,
  parseProviderFromState,
  publishOAuthResult,
  validateAndConsumeState,
} from "@/modules/Calendar/service/CalendarService"

const APP_SCHEME = "aplicativogiantsfrontend://app"
const FALLBACK_DELAY_MS = 1500

export default function OAuthCallbackPage() {
  const [showFallback, setShowFallback] = useState(false)
  const [message, setMessage] = useState("Autorizando, aguarde...")

  useEffect(() => {
    const hash = window.location.hash.substring(1)
    const search = window.location.search.substring(1)
    const params = new URLSearchParams(hash || search)

    const accessToken = params.get("access_token")
    const error = params.get("error")
    const rawState = params.get("state")

    if (!rawState) {
      window.location.replace("/")
      return
    }

    const validatedProvider = validateAndConsumeState(rawState)
    const resolvedProvider = validatedProvider ?? parseProviderFromState(rawState)

    if (!resolvedProvider) {
      setMessage("Não foi possível validar esta autorização. Feche esta aba e tente novamente.")
      setShowFallback(true)
      return
    }

    const { success: successType, error: errorType } = oauthMessageTypes(resolvedProvider)

    if (validatedProvider) {
      publishOAuthResult(validatedProvider, accessToken ? { token: accessToken } : { error: error ?? "unknown" })
    }

    if (window.opener) {
      if (accessToken) {
        window.opener.postMessage({ type: successType, token: accessToken }, window.location.origin)
      } else {
        window.opener.postMessage({ type: errorType, error }, window.location.origin)
      }
      window.close()
    }

    const redirectParams = new URLSearchParams({ provider: resolvedProvider, state: rawState })
    if (accessToken) {
      redirectParams.set("access_token", accessToken)
    } else {
      redirectParams.set("error", error ?? "unknown")
    }
    window.location.href = `${APP_SCHEME}/oauth/callback?${redirectParams}`

    const timer = setTimeout(() => {
      setMessage(
        accessToken
          ? "Autorização concluída. Você já pode fechar esta aba."
          : "Não foi possível concluir a autorização. Você pode fechar esta aba e tentar novamente."
      )
      setShowFallback(true)
    }, FALLBACK_DELAY_MS)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950 px-4">
      <div className="text-center">
        {!showFallback && (
          <div className="mx-auto mb-4 size-8 animate-spin rounded-full border-2 border-orange-500 border-t-transparent" />
        )}
        <p className="text-sm text-zinc-400">{message}</p>
        {showFallback && (
          <button
            onClick={() => window.close()}
            className="mt-4 rounded-lg border border-white/10 bg-white/5 px-4 py-2 text-sm text-white transition-colors hover:bg-white/10"
          >
            Fechar aba
          </button>
        )}
      </div>
    </div>
  )
}
